import Service from "./Service";

export default class SearchService extends Service {
    constructor() {
        super()
    }

    async getResults(query, type, extra_type, active) {
        let data = {
            authenticity_token: this.csrfToken(),
            keyword: query,
            type: type,
            extra_type: extra_type,
            active: active
        };
        let result = null;
        try {
            result = await $.ajax({
                url: `/${type}/search`,
                type: 'GET',
                dataType: 'json',
                data: data,
            });
        }
        catch (error) {
            console.error(error);
        }
        return result;
    }
}